import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { indexProjectsOrders } from "~/modules/project/api/order/orderApiDispatchers.ts";

export const orderQueries = {
	baseKey: ["orders"],
	byProject: (projectId: string) =>
		queryOptions({
			queryKey: [...orderQueries.baseKey, "project", projectId],
			queryFn: () => indexProjectsOrders(projectId).then(getDataFromResponse),
		}),
};
